export const ICON_DOWNLOAD = `
此页面中的所有图片只供您在您的产品架构图或者支持列表中用于代表 PingCAP 或者 TiDB 时使用。使用图片时，请标明图片来源为 PingCAP 官方网站。图片可以按比例调整大小，但不能以任何其他方式进行修改。

PingCAP<sup>®</sup>、PingCAP logo<sup>®</sup> 、TiDB<sup>®</sup> 和 TiDB logo<sup>®</sup> 是 PingCAP 在中国获得注册的注册商标。任何人未经 PingCAP 书面同意，不得使用这些图片作任何其他用途。

如有其他未尽事宜，请通过电子邮件 legal@pingcap.com 与我们取得联系。
`

export const ICON_NAMES = [
  "PingCAP （白底）",
  "PingCAP （黑底）",
  "PingCAP icon",
  "TiDB （白底）",
  "TiDB （黑底）",
  "TiDB icon",
]

export const SINGLE_ICON_ZIPS = [
  "https://img.pingcap.com/logo/1_PingCAP%20%E7%99%BD%E5%BA%95.zip",
  "https://img.pingcap.com/logo/2_PingCAP%20%E9%BB%91%E5%BA%95.zip",
  "https://img.pingcap.com/logo/3_PingCAP%20ICON.zip",
  "https://img.pingcap.com/logo/5_TiDB%20%E7%99%BD%E5%BA%95.zip",
  "https://img.pingcap.com/logo/6_TiDB%20%E9%BB%91%E5%BA%95.zip",
  "https://img.pingcap.com/logo/7_TiDB%20ICON.zip",
]

export const ICON_ZIPS = {
  PingCAP: {
    name: "PingCAP Logo 压缩包下载",
    url: "https://img.pingcap.com/logo/4_PingCAP%20Logo.zip",
  },
  TiDB: {
    name: "TiDB Logo 压缩包下载",
    url: "https://img.pingcap.com/logo/8_TiDB%20Logo.zip",
  },
}
